module.exports = __webpack_public_path__ + "static/media/Refer-Mobile-or-sheet.763c43ff.webp";